import { createSelector } from '@reduxjs/toolkit';

import {
  OBJECT_TYPE_ASSETS,
  OBJECT_TYPE_COLLECTIONS,
  type ObjectType,
} from '@iconik-io/iconik-api/src/types/object_types';

import { selectPermissions } from '../../components/permissions_manager/selectors';
import type { AppState } from '../../store/types';
import type { KeyframeWithId } from '../../types/files';
import { selectUserRoles } from '../../utils/get_user_roles';

const getKeyframes = (state: AppState) => state.entities.keyframes;

const getKeyframesIds = (state: AppState, entityId: string | undefined) =>
  entityId ? state.entityKeyframes.keyframesIdsByEntityId[entityId] : undefined;

export const getCanUploadPosters = (
  state: AppState,
  entityId: string | undefined,
  objectType: ObjectType,
): boolean => {
  const key =
    objectType === OBJECT_TYPE_COLLECTIONS
      ? OBJECT_TYPE_COLLECTIONS
      : OBJECT_TYPE_ASSETS;
  return Boolean(
    selectUserRoles(state).canWriteKeyframes &&
      selectPermissions(state, key, entityId)?.write,
  );
};

export const selectPosters = createSelector(
  [getKeyframes, getKeyframesIds],
  (keyframes = {}, ids = []) => {
    const posters: KeyframeWithId[] = [];
    ids.forEach((id) => {
      if (
        keyframes[id] &&
        keyframes[id].type === 'POSTER' &&
        keyframes[id].status === 'CLOSED'
      ) {
        posters.push(keyframes[id]);
      }
    });
    return posters;
  },
);
